module.exports = __webpack_public_path__ + "img/1440.a137bbb3.jpg";